'use client'

import { isMacarongApp } from '@/shared/lib'
import useIsMounted from '@/shared/model/useIsMounted'

/** 인앱 레이아웃 강제 미리보기용 쿼리 파라미터 (`?webview=1`) */
const WEBVIEW_PREVIEW_PARAM = 'webview'

const hasWebviewPreviewParam = (): boolean => {
  if (typeof window === 'undefined') return false
  return (
    new URLSearchParams(window.location.search).get(WEBVIEW_PREVIEW_PARAM) ===
    '1'
  )
}

/**
 * 인앱 여부 동기 판별 (마운트 게이트 없음).
 * 클라이언트 네비게이션에서만 렌더되는 loading.tsx처럼 하이드레이션 대상이 아닌
 * 곳에서, 마운트 지연으로 인한 깜빡임 없이 즉시 판별해야 할 때 사용.
 * SSR에서는 window가 없어 false.
 */
export const checkIsInApp = (): boolean =>
  isMacarongApp() || hasWebviewPreviewParam()

/**
 * 마이클 인앱 웹뷰에서 실행 중인지 여부.
 * SSR·최초 렌더에서는 항상 false(SEO 보존), 마운트 후 판별.
 * 판별: User-Agent 'Macarong' 포함 또는 `?webview=1`.
 */
export const useIsInApp = (): boolean => {
  const isMounted = useIsMounted()
  if (!isMounted) return false
  return checkIsInApp()
}
